import Colors from "../../../assets/Colors";

export const ReturnDetailsStyles = {
    printIcon: {
        width: '24px',
        height: '24px',
        paddingLeft: '5px',
        cursor: "pointer"
    },
    disableText: {
        color: Colors.napaBlueLink,
        textTransform: 'none'
    },
    gridContainer: {
        marginTop: 0,
        paddingInline: 5,
        textAlign: 'left'
    },
    title: {
        color: Colors.napaBlue,
        fontWeight: '700',
        fontSize: '22px',
        lineHeight: '28px',
        letterSpacing: '0.48px',
        marginBottom: 0
    },
    backButton: { padding: 0 },
    backButtonArrow: { padding: 0, color: Colors.napaGrey2 },
    backButtonText: {
        fontWeight: '400',
        fontSize: '14px',
        textTransform: 'initial',
        color: Colors.napaGrey2
    },
    actionButton: { boxShadow: 'none' },
    actionButtonDisabled: {
        boxShadow: 'none',
        color: Colors.napaGreyDisabled2,
        backgroundColor: 'white',
        border: `1px solid ${Colors.napaGreyDisabled2}`
    },
    viewSignatureButton: { borderRight: '1px solid blue', borderRadius: '0', padding: '0 8px' },
    printButton: { padding: '0 8px' },
    confirmReturnsButton: { marginLeft: 'auto', marginTop: '10px' },
    gridDetail: {
        display: 'flex',
        alignItems: 'flex-start'
    },
    gridSize: {
        border: 0,
        '& .MuiDataGrid-columnHeaders': {
            fontSize: '12px',
            fontFamily: '400',
            lineHeight: '15px',
            letterSpacing: '0.42px',
            color: '#707070'
        },
        '& .MuiDataGrid-cell': {
            fontSize: '14px',
            color: '#33333',
            lineHeight: '22px',
            letterSpacing: '0.48px'
        },
        '& .MuiDataGrid-cell:focus': {
            outline: 'none'
        },
        '&.MuiDataGrid-root .MuiDataGrid-columnHeader:focus': {
            outline: 'none',
            color: '#001489',
            fontWeight: 'bolder'
        },
        '& .MuiDataGrid-columnHeaderTitleContainerContent:focus': {
            fontWeight: 'bolder'
        },
        '& .MuiDataGrid-columnSeparator': {
            display: 'none'
        },
        '& .MuiDataGrid-virtualScrollerRenderZone': {
            '& .MuiDataGrid-row': {
                '&:nth-of-type(2n-1)': { backgroundColor: '#F4F4F4' },
                '&:nth-of-type(2n-1):hover': { backgroundColor: '#E5E7F3' },
                '&:nth-of-type(2n):hover': { backgroundColor: '#E5E7F3' }
            }
        },
        '& .MuiDataGrid-sortIcon': {
            color: '#001489',
            outline: 'none'
        },
        '& .MuiDataGrid-row:hover': {
            backgroundColor: '#E5E7F3'
        },
        '& [title="PENDING"], & [title="DRIVER RECEIVED"]': {
            color: Colors.napaGrey2,
            backgroundColor: '#d9d9d9',
            borderRadius: '4px',
            padding: '5px 10px'
        },
        '& [title="VERIFIED"]': {
            color: Colors.napaGreenDark,
            backgroundColor: '#d9d9d9',
            borderRadius: '4px',
            padding: '5px 10px'
        },
        '& [title="REJECTED"]': {
            color: Colors.napaRed3,
            backgroundColor: '#FCEDEE',
            borderRadius: '4px',
            padding: '5px 10px'
        }
    },
    validateContainer: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    firstStage: (value: string) => ({
        boxShadow: 'none',
        border: '2px solid green',
        backgroundColor: value === 'DRIVER_RECEIVED' ? 'green' : 'transparent',
        color: value === 'DRIVER_RECEIVED' ? 'white' : 'green',
        width: '40px',
        height: '40px',
        minHeight: 'auto'
    }),
    fab: { boxShadow: 'none', color: Colors.napaGreyDisabled2, backgroundColor: 'white', border: `1px solid ${Colors.napaGreyDisabled2}` },
    secondStage: (value: string) => ({
        boxShadow: 'none',
        border: '2px solid green',
        backgroundColor: value === 'PENDING_VERIFICATION' ? 'green' : 'transparent',
        color: value === 'PENDING_VERIFICATION' ? 'white' : 'green',
        width: '40px',
        height: '40px',
        minHeight: 'auto'
    }),
    thirdStage: (value: string) => ({
        boxShadow: 'none',
        border: '2px solid green',
        backgroundColor: value === 'VERIFIED' ? 'green' : 'transparent',
        color: value === 'VERIFIED' ? 'white' : 'green',
        width: '40px',
        height: '40px',
        minHeight: 'auto'
    }),
    notesSection: {
        '& .MuiOutlinedInput-root': {
            height: '50px',
            '& fieldset': { borderColor: 'transparent' },
            '&:hover fieldset': { borderColor: 'transparent' },
            '&.Mui-disabled': {
                '& fieldset': { borderColor: 'transparent' }
            }
        },
    },
    editButton: {
        textTransform: 'none',
        background: 'transparent',
        color: Colors.napaGreenDark,
        ':disabled': {
            color: Colors.napaGreyDisabled2
        }
    },
    rejectButton: {
        width: '10%',
        margin: '4px',
        ':disabled': {
            borderColor: Colors.napaGreyDisabled
        }
    },
    verifyButton: {
        width: '10%',
        margin: '4px'
    },
    qTip: {
        fontSize: '12px',
        fontWeight: '400',
        color: '#707070',
        display: 'flex',
        justifyContent: 'end'
    },
    description: {
        marginTop: '0px',
        marginLeft: '50px',
        fontSize: '14px'
    },
    completedContainer: {
        border: `1px solid ${Colors.napaGreyDisabled2}`,
        padding: '10px',
        marginTop: '10px',
    }
}
